import { useMutation } from '@apollo/client';
import { ADD_TO_WISHLIST, REMOVE_FROM_WISHLIST } from 'graphql/mutations';
import useWishlistData from 'hooks/account/useWishlistData';
import { useViewportWidth } from '@xstyled/styled-components';
import newItemInWishlistToast from '@/UI/Toast/WishlistToast';
import { useRouter } from 'next/router';
export default function useWishlist(product) {
  const router = useRouter()
  const lang = router.locale ? router.locale : 'et';
  const viewportWidth = useViewportWidth();
  const isDesktop = viewportWidth >= 1024;

  const { id, itemId } = useWishlistData(product);

  const simpleProduct = product?.__typename === 'SimpleProduct';
  const item = simpleProduct
    ? { sku: product?.sku }
    : { parent_sku: product?.sku, sku: product?.sku };

  const [add] = useMutation(ADD_TO_WISHLIST, {
    variables: { id, item: { ...item, quantity: 1 } }
  });

  const [remove] = useMutation(REMOVE_FROM_WISHLIST, {
    variables: { id, itemId }
  });

  const addToWishlist = async () => {
    await add();
    newItemInWishlistToast({
      item: product?.name,
      action: 'add',
      isDesktop,
      lang
    });
  };

  const removeFromWishlist = async () => {
    await remove();
    newItemInWishlistToast({
      item: product?.name,
      action: 'remove',
      isDesktop,
      lang
    });
  };

  return { addToWishlist, removeFromWishlist };
}
